namespace SorAraBul.Administration {
    export interface PurchasePackageFeaturesForm {
        FeatureText: Serenity.StringEditor;
        SortOrder: Serenity.IntegerEditor;
    }

    export class PurchasePackageFeaturesForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PurchasePackageFeatures';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PurchasePackageFeaturesForm.init)  {
                PurchasePackageFeaturesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(PurchasePackageFeaturesForm, [
                    'FeatureText', w0,
                    'SortOrder', w1
                ]);
            }
        }
    }
}
